import { unsubscribeContact } from "@/services";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router";

export default function Unsubscribe() {
  const { token } = useParams();
  const [status, setStatus] = useState<"pending" | "done" | "failed">(
    "pending",
  );

  // Scanners that prefetch links in email don't run JS, so firing the request
  // on mount keeps them from unsubscribing people who never clicked.
  const fired = useRef(false);

  useEffect(() => {
    if (!token || fired.current) return;
    fired.current = true;

    unsubscribeContact(token)
      .then(() => setStatus("done"))
      .catch(() => setStatus("failed"));
  }, [token]);

  if (status === "pending") return null;

  return (
    <section className="hero">
      <div
        className="mx-auto flex w-full max-w-4xl  
        flex-col items-center gap-6 p-5 text-center "
      >
        <h2 className="text-3xl font-normal">
          {status === "done"
            ? "You've unsubscribed from all marketing emails."
            : "We couldn't process that just now."}
        </h2>

        {status === "failed" && (
          <p className="text-base text-muted-foreground">
            Please email{" "}
            <a className="underline" href="mailto:support@sakeena.io">
              support@sakeena.io
            </a>{" "}
            and we'll take care of it.
          </p>
        )}
      </div>
    </section>
  );
}
